module.exports = __webpack_public_path__ + "img/logo-presse-journal-des-entreprises_200x200.d4a7e40b.jpg";